import type {ReadingContext} from "../../types";
import type {DibDocument} from "./types";

/** Only report the loaded document, never the retained chrome from a previous segment. */
export function readingContextForDocument(
    doc: DibDocument | undefined,
    resourceId: string,
    segmentId: string | undefined,
    activeId: string | null | undefined,
): ReadingContext | null {
    if (!doc?.access || !doc.root.length || doc.topicId.toLowerCase() !== resourceId.toLowerCase()) return null;
    const tocEntries = Object.values(doc.toc);
    const section = activeId && doc.elements[activeId]
        ? tocEntries.find(node => node.attributes.id === activeId) : undefined;
    const actualSegment = doc.segmentId || segmentId;
    const segment = tocEntries.find(node => node.attributes.id === actualSegment);
    return {
        topicId: resourceId,
        topicTitle: doc.name,
        segmentId: actualSegment || undefined,
        segmentTitle: segment?.attributes.title,
        // The observer's previous id can survive a segment change until its next update.
        sectionId: section ? activeId! : undefined,
        sectionTitle: section?.attributes.title,
    };
}
